"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// @inheritedComponent Tooltip
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _Fab = _interopRequireDefault(require("../Fab"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _speedDialActionClasses = _interopRequireWildcard(require("./speedDialActionClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var open = ownerState.open, tooltipPlacement = ownerState.tooltipPlacement, classes = ownerState.classes;
    var slots = {
        fab: [
            'fab',
            !open && 'fabClosed'
        ],
        staticTooltip: [
            'staticTooltip',
            "tooltipPlacement".concat((0, _capitalize.default)(tooltipPlacement)),
            !open && 'staticTooltipClosed'
        ],
        staticTooltipLabel: [
            'staticTooltipLabel'
        ]
    };
    return (0, _composeClasses.default)(slots, _speedDialActionClasses.getSpeedDialActionUtilityClass, classes);
};
var SpeedDialActionFab = (0, _zeroStyled.styled)(_Fab.default, {
    name: 'MuiSpeedDialAction',
    slot: 'Fab',
    skipVariantsResolver: false,
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        margin: 8,
        color: (theme.vars || theme).palette.text.secondary,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, _colorManipulator.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: "".concat(theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        }), ", opacity 0.8s"),
        opacity: 1,
        variants: [
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return !ownerState.open;
                },
                style: {
                    opacity: 0,
                    transform: 'scale(0)'
                }
            }
        ]
    };
}));
var SpeedDialActionStaticTooltip = (0, _zeroStyled.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltip',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles["tooltipPlacement".concat((0, _capitalize.default)(ownerState.tooltipPlacement))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, _define_property(_obj, "& .".concat(_speedDialActionClasses.default.staticTooltipLabel), {
        transition: theme.transitions.create([
            'transform',
            'opacity'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        opacity: 1
    }), _define_property(_obj, "variants", [
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return !ownerState.open;
            },
            style: _define_property({}, "& .".concat(_speedDialActionClasses.default.staticTooltipLabel), {
                opacity: 0,
                transform: 'scale(0.5)'
            })
        },
        {
            props: {
                tooltipPlacement: 'left'
            },
            style: _define_property({}, "& .".concat(_speedDialActionClasses.default.staticTooltipLabel), {
                transformOrigin: '100% 50%',
                right: '100%',
                marginRight: 8
            })
        },
        {
            props: {
                tooltipPlacement: 'right'
            },
            style: _define_property({}, "& .".concat(_speedDialActionClasses.default.staticTooltipLabel), {
                transformOrigin: '0% 50%',
                left: '100%',
                marginLeft: 8
            })
        }
    ]), _obj;
}));
var SpeedDialActionStaticTooltipLabel = (0, _zeroStyled.styled)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltipLabel',
    overridesResolver: function(props, styles) {
        return styles.staticTooltipLabel;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _object_spread_props(_object_spread({
        position: 'absolute'
    }, theme.typography.body1), {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        boxShadow: (theme.vars || theme).shadows[1],
        color: (theme.vars || theme).palette.text.secondary,
        padding: '4px 16px',
        wordBreak: 'keep-all'
    });
}));
var SpeedDialAction = /*#__PURE__*/ React.forwardRef(function SpeedDialAction(inProps, ref) {
    var _externalForwardedProps_slotProps_tooltip;
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialAction'
    });
    var className = props.className, _props_delay = props.delay, delay = _props_delay === void 0 ? 0 : _props_delay, _props_FabProps = props.FabProps, FabProps = _props_FabProps === void 0 ? {} : _props_FabProps, icon = props.icon, id = props.id, open = props.open, TooltipClasses = props.TooltipClasses, tmp = props.tooltipOpen, tooltipOpenProp = tmp === void 0 ? false : tmp, _props_tooltipPlacement = props.tooltipPlacement, tooltipPlacement = _props_tooltipPlacement === void 0 ? 'left' : _props_tooltipPlacement, tooltipTitle = props.tooltipTitle, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "className",
        "delay",
        "FabProps",
        "icon",
        "id",
        "open",
        "TooltipClasses",
        "tooltipOpen",
        "tooltipPlacement",
        "tooltipTitle",
        "slots",
        "slotProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        tooltipPlacement: tooltipPlacement
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread_props(_object_spread({
            fab: FabProps
        }, slotProps), {
            tooltip: (0, _utils.mergeSlotProps)(typeof slotProps.tooltip === 'function' ? slotProps.tooltip(ownerState) : slotProps.tooltip, {
                title: tooltipTitle,
                open: tooltipOpenProp,
                placement: tooltipPlacement,
                classes: TooltipClasses
            })
        })
    };
    var _React_useState = _sliced_to_array(React.useState((_externalForwardedProps_slotProps_tooltip = externalForwardedProps.slotProps.tooltip) === null || _externalForwardedProps_slotProps_tooltip === void 0 ? void 0 : _externalForwardedProps_slotProps_tooltip.open), 2), tooltipOpen = _React_useState[0], setTooltipOpen = _React_useState[1];
    var handleTooltipClose = function() {
        setTooltipOpen(false);
    };
    var handleTooltipOpen = function() {
        setTooltipOpen(true);
    };
    var transitionStyle = {
        transitionDelay: "".concat(delay, "ms")
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('fab', {
        elementType: SpeedDialActionFab,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.fab, className),
        additionalProps: {
            style: transitionStyle,
            tabIndex: -1,
            role: 'menuitem',
            size: 'small'
        }
    }), 2), FabSlot = _ref[0], fabSlotProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('tooltip', {
        elementType: _Tooltip.default,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ref: ref,
        additionalProps: {
            id: id
        },
        ownerState: ownerState,
        getSlotProps: function(handlers) {
            return _object_spread_props(_object_spread({}, handlers), {
                onClose: function(event) {
                    var _handlers_onClose;
                    (_handlers_onClose = handlers.onClose) === null || _handlers_onClose === void 0 ? void 0 : _handlers_onClose.call(handlers, event);
                    handleTooltipClose();
                },
                onOpen: function(event) {
                    var _handlers_onOpen;
                    (_handlers_onOpen = handlers.onOpen) === null || _handlers_onOpen === void 0 ? void 0 : _handlers_onOpen.call(handlers, event);
                    handleTooltipOpen();
                }
            });
        }
    }), 2), TooltipSlot = _ref1[0], tooltipSlotProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('staticTooltip', {
        elementType: SpeedDialActionStaticTooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: ref,
        className: classes.staticTooltip,
        additionalProps: {
            id: id
        }
    }), 2), StaticTooltipSlot = _ref2[0], staticTooltipSlotProps = _ref2[1];
    var _ref3 = _sliced_to_array((0, _useSlot.default)('staticTooltipLabel', {
        elementType: SpeedDialActionStaticTooltipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.staticTooltipLabel,
        additionalProps: {
            style: transitionStyle,
            id: "".concat(id, "-label")
        }
    }), 2), StaticTooltipLabelSlot = _ref3[0], staticTooltipLabelSlotProps = _ref3[1];
    var fab = /*#__PURE__*/ (0, _jsxRuntime.jsx)(FabSlot, _object_spread_props(_object_spread({}, fabSlotProps), {
        children: icon
    }));
    if (tooltipSlotProps.open) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StaticTooltipSlot, _object_spread_props(_object_spread({}, staticTooltipSlotProps, other), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StaticTooltipLabelSlot, _object_spread_props(_object_spread({}, staticTooltipLabelSlotProps), {
                    children: tooltipSlotProps.title
                })),
                /*#__PURE__*/ React.cloneElement(fab, {
                    'aria-labelledby': "".concat(id, "-label")
                })
            ]
        }));
    }
    if (!open && tooltipOpen) {
        setTooltipOpen(false);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TooltipSlot, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, tooltipSlotProps), {
        title: tooltipSlotProps.title,
        open: open && tooltipOpen,
        placement: tooltipSlotProps.placement,
        classes: tooltipSlotProps.classes
    }), other), {
        children: fab
    }));
});
process.env.NODE_ENV !== "production" ? SpeedDialAction.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   * @default 0
   */ delay: _propTypes.default.number,
    /**
   * Props applied to the [`Fab`](https://mui.com/material-ui/api/fab/) component.
   * @default {}
   * @deprecated Use `slotProps.fab` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ FabProps: _propTypes.default.object,
    /**
   * The icon to display in the SpeedDial Fab.
   */ icon: _propTypes.default.node,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: _propTypes.default.string,
    /**
   * If `true`, the component is shown.
   */ open: _propTypes.default.bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        fab: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        staticTooltip: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        staticTooltipLabel: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        tooltip: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        fab: _propTypes.default.elementType,
        staticTooltip: _propTypes.default.elementType,
        staticTooltipLabel: _propTypes.default.elementType,
        tooltip: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * `classes` prop applied to the [`Tooltip`](https://mui.com/material-ui/api/tooltip/) element.
   * @deprecated Use `slotProps.tooltip.classes` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ TooltipClasses: _propTypes.default.object,
    /**
   * Make the tooltip always visible when the SpeedDial is open.
   * @default false
   * @deprecated Use `slotProps.tooltip.open` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipOpen: _propTypes.default.bool,
    /**
   * Placement of the tooltip.
   * @default 'left'
   * @deprecated Use `slotProps.tooltip.placement` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipPlacement: _propTypes.default.oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Label to display in the tooltip.
   * @deprecated Use `slotProps.tooltip.title` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ tooltipTitle: _propTypes.default.node
} : void 0;
var _default = exports.default = SpeedDialAction;
